import { SystemPrivilege } from '@/entities/authentication';
import { privilegeGuardRoute } from '@/features/authenticate';
import { IncidentCreatePage } from '@/pages/events';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_private/events/$eventUuid/incident/create',
)({
  beforeLoad: () => {
    privilegeGuardRoute({ privileges: [SystemPrivilege.ManageIncidentForm] });
  },
  component: IncidentCreatePage,
});
